import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { ApiUrl } from '../api-core/api-constants';
import { apiGet, apiPost } from '../api-core/api-request';
import apiRequestHookFactory from '../api-core/utility-factories/api-request-hook-factory';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import { apiRedux } from '../api-redux';
import {
  CreateCustomProductReq,
  Product,
  ProductBrand,
  ProductCategory,
  ProductCategoryByBrand,
  ProductFromSearchV1,
  ProductSearchQuery,
  ProductSearchV1Res,
  searchResToProductFromSearchV1,
} from './api-product.types';

export const useGetProductByUpc = apiRequestHookFactory(
  apiRedux.getProduct,
  (upcCode: string): Observable<ProductFromSearchV1> =>
    apiGet<ProductSearchV1Res[]>(ApiUrl.PRODUCTS, {
      urlParams: { upc: upcCode },
    }).pipe(map(searchResToProductFromSearchV1), pluck(0))
);

export const useSearchProductCatalog = apiRequestHookFactory(
  apiRedux.searchProducts,
  ({
    search,
    motorcyclesOnly,
  }: ProductSearchQuery): Observable<ProductFromSearchV1[]> =>
    apiGet<ProductSearchV1Res[]>(
      motorcyclesOnly ? ApiUrl.MOTORCYCLES : ApiUrl.PRODUCTS,
      { urlParams: { search } },
      false
    ).pipe(map(searchResToProductFromSearchV1))
);

// export const useSearchProductCatalogV2 = apiRequestHookFactory(
//   apiRedux.searchProducts,
//   ({
//     search,
//     brand,
//   }: ProductSearchQuery): Observable<ProductFromSearchV1[]> =>
//     apiGet<ProductSearchV1Res[]>(
//       ApiUrl.PRODUCTSV2,
//       { urlParams: { search, brand: brand ?? '' } },
//       false
//     ).pipe(map(searchResToProductFromSearchV1))
// );

// export const useSearchProductCatalogV2 = apiRequestHookFactory(
//   apiRedux.searchProducts,
//   ({
//     search,
//   }: ProductSearchQuery): Observable<ProductFromSearchV1[]> =>
//     apiGet<ProductSearchV1Res[]>(
//       'https://2q0sdr9vpk.execute-api.eu-west-2.amazonaws.com/dev/products',
//       { urlParams: { search } },
//       false
//     ).pipe(map(searchResToProductFromSearchV1))
// );

export const useSearchProductCatalogV2 = apiRequestHookFactory(
  apiRedux.searchProducts,
  ({
    search,
  }: ProductSearchQuery): Observable<ProductFromSearchV1[]> =>
    apiGet<ProductSearchV1Res[]>(
      ApiUrl.PRODUCT_SEARCH,
      { urlParams: { search } },
      false
    ).pipe(map(searchResToProductFromSearchV1))
);

export const useProductCategories = apiResourceHookFactory(
  apiRedux.productCategories,
  (): Observable<ProductCategory[]> =>
    apiGet<ProductCategory[]>(ApiUrl.PRODUCT_CATEGORIES)
);

export const useProductCategoriesByBrand = apiResourceHookFactory(
  apiRedux.productCategoriesByBrand,
  (id: number): Observable<ProductCategoryByBrand[]> =>
    apiGet<ProductCategoryByBrand[]>(
      `${ApiUrl.PRODUCT_CATEGORIESBYBRAND}/${id}`
    )
);

export const useProductBrands = apiResourceHookFactory(
  apiRedux.productBrands,
  (): Observable<ProductBrand[]> =>
    apiGet<ProductBrand[]>(ApiUrl.PRODUCT_BRANDS)
);

export const useCreateCustomProduct = apiRequestHookFactory(
  apiRedux.createCustomProduct,
  (data: CreateCustomProductReq): Observable<Product> =>
    apiPost<Product>(ApiUrl.CREATE_MANUAL_PRODUCT, data)
);
